export default __webpack_public_path__ + "static/media/image36.82e37aaa.jpg";